<template>
  <v-card :class="margin">
    <alert-header-panel :panel-type="panelType"
                        :panel-colour="panelColour"
                        :checkbox-value="dataSetCheckbox"
                        @set-checkbox="showAllDataSets"
                        :checkbox-id="dataSetCheckboxId"/>

    <v-list id="alert-data-set-list" dense class="py-0">
      <v-progress-linear v-if="dataSetsLoading" height="2" indeterminate color="accent" class="my-0"></v-progress-linear>
      <alert-data-set-item v-for="(dataSet, key) in dataSetItems"
                           :key="key"
                           v-if="dataSet.submitted && !dataSet.isDeleted"
                           :data-set="dataSet"
                           :data-set-key="key"
                           :panel-colour="panelColour" :first-element="firstElement"/>
      <v-divider/>
      <v-btn id="new-data-set-item" aria-label="new-data-set-item" @click="clickNewDataSet" :disabled="checkSubmitted" block flat class="my-0 text-capitalize ignore-none">
        <span>{{$t('admin.alerts.new.data_sets.new')}}</span>
        <v-spacer/>
        <v-icon>add</v-icon>
      </v-btn>
    </v-list>
  </v-card>
</template>
<script>
  import AlertHeaderPanel from './AlertHeaderPanel'
  import { CREATE_NEW_DATA_SET_ITEM, SHOW_ALL_DATA_SETS } from '../../../store/mutation-types'
  import AlertDataSetItem from './AlertDataSetItem'
  export default {
    name: 'alert-datasets',
    components: {AlertDataSetItem, AlertHeaderPanel},
    data () {
      return {
        panelType: {
          title: 'admin.alerts.new.data_sets.title',
          info: 'admin.alerts.new.data_sets.info'
        }
      }
    },
    props: {
      margin: {},
      panelColour: {}
    },
    methods: {
      showAllDataSets (value) {
        this.$store.commit(SHOW_ALL_DATA_SETS, value)
      },
      clickNewDataSet () {
        if (!this.checkSubmitted) {
          this.$store.commit(CREATE_NEW_DATA_SET_ITEM)
        }
      }
    },
    computed: {
      dataSetCheckbox () {
        return this.dataSetItems
          ? this.dataSetItems.filter(el => el.visible).length === this.dataSetItems.length
          : false
      },
      dataSetItems () {
        return this.$store.state.admin.newSingleAlert.dataSets
      },
      firstElement () {
        if (this.dataSetItems) {
          return this.dataSetItems.filter(el => !el.isDeleted).map(el => el.id)[0]
        }
      },
      checkSubmitted () {
        return this.dataSetItems
          ? this.dataSetItems.filter(el => !el.submitted).length > 0
          : false
      },
      dataSetCheckboxId () {
        return 'show-all-data-sets'
      },
      dataSetsLoading () {
        return this.$store.state.admin.dataSetsLoading
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertDatasets.vue